import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Bodegas.css';
import './MobileNav.css';
import logo from '../assets/logoblanco-def.png';
import favicon from '../assets/favicon.png';
import { useCart } from '../context/CartContext';
import { useNavbarScroll } from '../hooks/useNavbarScroll';
import MobileNav from './MobileNav';
import MapaUruguay from '../assets/mapa5.svg';

import imgCanelon from '../assets/bode-canelon.jpg';
import imgSauce from '../assets/bodegas-roses.jpg';
import winecurv01 from '../assets/winecurv_15_1-Convertido-01.png';
import winecurv02 from '../assets/winecurv_15_1-Convertido-02.png';
import winecurv04 from '../assets/winecurv_15_1-Convertido-04.png';
import winecurv05 from '../assets/winecurv_15_1-Convertido-05.png';
import winecurv06 from '../assets/winecurv_15_1-Convertido-06.png';
import winecurv14 from '../assets/winecurv_15_1-Convertido-14.png';
import winecurv17 from '../assets/winecurv_15_1-Convertido-17.png';
import winecurv18 from '../assets/winecurv_15_1-Convertido-18.png';
import winecurv22 from '../assets/winecurv_15_1-Convertido-22.png';
import winecurv24 from '../assets/winecurv_15_1-Convertido-24.png';
import winecurv25 from '../assets/winecurv_15_1-Convertido-25.png';
import winecurv27 from '../assets/winecurv_15_1-Convertido-27.png';

const BODEGAS_DATA = [
  {
    id: 'canelon-chico',
    title: 'Paraje de Canelón Chico',
    description: 'El primero se encuentra en Ruta 32 km 27.500, en el paraje de Canelón Chico, donde se recibe la uva durante la zafra de la vendimia y se produce el vino.',
    image: imgCanelon,
  },
  {
    id: 'sauce',
    title: 'Sauce',
    description: 'El segundo está ubicado en Ruta 6 km 30.200, en Sauce, en el que se envasan los productos antes de salir al mercado.',
    image: imgSauce,
  },
];

const VINEDOS_IMAGES = [
  require('../assets/vinedos.jpg'),
  require('../assets/vinedos2.jpg'),
  require('../assets/vinedos3.jpg'),
  require('../assets/vinedos4.jpg'),
  require('../assets/vinedos5.jpg'),
  require('../assets/vinedos6.jpg'),
  require('../assets/vinedos7.jpg'),
];

const BENTO_LAYOUT = [
  { gridColumn: 1, gridRow: '1 / 4' },
  { gridColumn: 2, gridRow: '1 / 2' },
  { gridColumn: 2, gridRow: '2 / 4' },
  { gridColumn: 1, gridRow: '4 / 7' },
  { gridColumn: 2, gridRow: '4 / 5' },
  { gridColumn: 2, gridRow: '5 / 7' },
  { gridColumn: '1 / -1', gridRow: '7 / 9' },
];

const Bodegas = () => {
  const navigate = useNavigate();
  const { toggleCart, getTotalItems } = useCart();
  const [navReady, setNavReady] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { hidden: navbarHidden, compact: navbarCompact } = useNavbarScroll();
  const vinedosSectionRef = useRef(null);
  const [counts] = useState({ canelones: 359, sanJose: 51, montevideo: 16 });
  const [lightboxIndex, setLightboxIndex] = useState(null);

  useEffect(() => {
    if (window.location.hash !== '#vinedos') window.scrollTo(0, 0);
    const t = setTimeout(() => setNavReady(true), 100);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    if (window.location.hash === '#vinedos') {
      const t = setTimeout(() => {
        document.getElementById('vinedos')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 300);
      return () => clearTimeout(t);
    }
  }, []);


  useEffect(() => {
    if (lightboxIndex === null) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const onKey = (e) => { if (e.key === 'Escape') setLightboxIndex(null); };
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = prev;
      window.removeEventListener('keydown', onKey);
    };
  }, [lightboxIndex]);

  return (
    <div className="bodegas-page">
      <img src={winecurv01} alt="" className="bodegas-wine-decor bodegas-wine-decor-1" />
      <img src={winecurv02} alt="" className="bodegas-wine-decor bodegas-wine-decor-2" />
      <img src={winecurv06} alt="" className="bodegas-wine-decor bodegas-wine-decor-3" />
      <img src={winecurv18} alt="" className="bodegas-wine-decor bodegas-wine-decor-4" />
      <img src={winecurv22} alt="" className="bodegas-wine-decor bodegas-wine-decor-5" />
      <img src={winecurv25} alt="" className="bodegas-wine-decor bodegas-wine-decor-6" />
      <img src={winecurv04} alt="" className="bodegas-wine-decor bodegas-wine-decor-7" />
      <img src={winecurv17} alt="" className="bodegas-wine-decor bodegas-wine-decor-8" />
      <img src={winecurv24} alt="" className="bodegas-wine-decor bodegas-wine-decor-9" />
      <img src={winecurv05} alt="" className="bodegas-wine-decor bodegas-wine-decor-10" />
      <img src={winecurv14} alt="" className="bodegas-wine-decor bodegas-wine-decor-11" />
      <img src={winecurv27} alt="" className="bodegas-wine-decor bodegas-wine-decor-12" />

      <nav className={`bodegas-navbar${navReady ? ' bodegas-nav-ready' : ''}${navbarHidden ? ' navbar-hidden' : ''}${navbarCompact ? ' navbar-compact' : ''}`}>
        <div className="bodegas-navbar-content">
          <div className="bodegas-nav-left">
            <button onClick={() => navigate('/')} className="bodegas-nav-link">INICIO</button>
            <button onClick={() => navigate('/equipo')} className="bodegas-nav-link">EQUIPO</button>
            <button onClick={() => navigate('/bodegas')} className="bodegas-nav-link">BODEGAS</button>
          </div>
          <div className="bodegas-nav-center">
            <button onClick={() => navigate('/')}>
              <img src={logo} alt="Rosés Wines" className="bodegas-nav-logo" />
            </button>
          </div>
          <div className="bodegas-nav-right">
            <button onClick={() => navigate('/historia')} className="bodegas-nav-link">HISTORIA</button>
            <button onClick={() => navigate('/kit-de-marca')} className="bodegas-nav-link">KIT DE MARCA</button>
            <button onClick={() => navigate('/#tienda')} className="bodegas-nav-link">TIENDA</button>
            <button className="bodegas-nav-link bodegas-cart" onClick={toggleCart}>
              <span className="cart-icon">🛒</span>
              {getTotalItems() > 0 && (
                <span className="bodegas-cart-badge">{getTotalItems()}</span>
              )}
            </button>
          </div>
          <button
            type="button"
            className={`mobile-nav-hamburger${mobileMenuOpen ? ' open' : ''}`}
            onClick={() => setMobileMenuOpen((o) => !o)}
            aria-expanded={mobileMenuOpen}
            aria-label="Menú"
          >
            <span className="mobile-nav-hamburger-line" />
            <span className="mobile-nav-hamburger-line" />
            <span className="mobile-nav-hamburger-line" />
          </button>
        </div>
      </nav>

      <MobileNav open={mobileMenuOpen} onClose={() => setMobileMenuOpen(false)} />

      <section className="bodegas-hero">
        <div className="bodegas-hero-icon">
          <img src={favicon} alt="" />
        </div>
        <h1 className="bodegas-hero-title">BODEGAS</h1>
        <p className="bodegas-hero-subtitle">
          En la actualidad, la bodega cuenta con dos establecimientos, ambos ubicados en el departamento de Canelones.
        </p>
        <button className="bodegas-scroll-indicator" onClick={() => document.getElementById('canelon-chico')?.scrollIntoView({ behavior: 'smooth', block: 'start' })} aria-label="Bajar">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M12 5v14M19 12l-7 7-7-7" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
      </section>

      {BODEGAS_DATA.map((bodega) => (
        <section key={bodega.id} id={bodega.id} className={`bodega-block ${bodega.id === 'sauce' ? 'bodega-block--sauce' : ''}`}>
          <div className="bodega-block-inner">
            <div className="bodega-text">
              <div className="bodega-icon">
                <img src={favicon} alt="" />
              </div>
              <h2 className="bodega-title">{bodega.title}</h2>
              <p className="bodega-description">{bodega.description}</p>
            </div>
            <div className="bodega-image-wrap">
              <img src={bodega.image} alt={bodega.title} className="bodega-image" />
            </div>
          </div>
        </section>
      ))}

      <section id="vinedos" className="vinedos-section" ref={vinedosSectionRef}>
        <div className="vinedos-hero" style={{ backgroundImage: `url(${VINEDOS_IMAGES[1]})` }}>
          <div className="vinedos-hero-overlay" />
          <div className="vinedos-hero-content">
            <h2 className="vinedos-section-title">Nuestros Viñedos</h2>
          </div>
        </div>
        <div className="vinedos-container">
          <div className="vinedos-content">
            <div className="mapa-container">
              <img src={MapaUruguay} alt="Mapa de Uruguay - Viñedos" className="mapa-uruguay" />
            </div>
            <div className="vinedos-info">
              <div className="region-text">
                <div className="region-line region-line--primary">
                  <span className="region-line-name">Canelones</span>
                  <span className="region-line-sep">:</span>
                  <span className="region-line-value">
                    <span className="region-line-number">{counts.canelones}</span> Hectáreas
                  </span>
                </div>
                <div className="region-line region-line--primary">
                  <span className="region-line-name">San José</span>
                  <span className="region-line-sep">:</span>
                  <span className="region-line-value">
                    <span className="region-line-number">{counts.sanJose}</span> hectáreas
                  </span>
                </div>
                <div className="region-line region-line--accent">
                  <span className="region-line-name">Montevideo</span>
                  <span className="region-line-sep">:</span>
                  <span className="region-line-value">
                    <span className="region-line-number">{counts.montevideo}</span> hectáreas
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="vinedos-gallery">
            <div className="vinedos-gallery-bento" role="region" aria-label="Galería de viñedos">
              {VINEDOS_IMAGES.map((src, i) => (
                <button
                  key={i}
                  type="button"
                  className="vinedos-gallery-item"
                  style={BENTO_LAYOUT[i]}
                  onClick={() => setLightboxIndex(i)}
                  aria-label={`Ampliar viñedo ${i + 1}`}
                >
                  <img src={src} alt={`Viñedo Rosés ${i + 1}`} className="vinedos-gallery-img" />
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>

      {lightboxIndex !== null && (
        <div
          className="vinedos-lightbox"
          onClick={() => setLightboxIndex(null)}
          role="dialog"
          aria-modal="true"
          aria-label="Imagen ampliada"
        >
          <button
            type="button"
            className="vinedos-lightbox-close"
            onClick={() => setLightboxIndex(null)}
            aria-label="Cerrar"
          >
            ×
          </button>
          <img
            src={VINEDOS_IMAGES[lightboxIndex]}
            alt={`Viñedo Rosés ${lightboxIndex + 1}`}
            className="vinedos-lightbox-img"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
};

export default Bodegas;
